<template>
  <div class="quality quality-submit">
    <z-form label-width="100px" @submit="onSubmit" @failed="onFailed">
      <z-cell-group inset :style="{ margin: 0 }">
        <z-cell :border="false">
          <div class="title" slot="title">营业执照信息</div>
        </z-cell>
      <section class="upload-area">
        <evidence-upload-item class="evidence" type="front" tip="点击上传彩色原件或加盖公司公章的复印件" @uploaded="UploadedEvi" :sheet="true" :ocr="true">
          <div class="sample-cover"></div>
        </evidence-upload-item>
      </section>

      <z-field
        v-model="bizName"
        name="bizName"
        label="企业名称"
        label-width="100px"
        placeholder="请输入认证企业名称"
      />

      <z-field
        v-model="creditCode"
        name="creditCode"
        label="社会信用代码"
        label-width="100px"
        placeholder="请输入认证企业社会信用代码"
      />
     </z-cell-group>
     <div :style="{height: '30px'}"></div>
     <z-cell-group inset :style="{ margin: 0 }">
      <z-cell :border="false">
        <div class="title" slot="title">法定代表人信息</div>
      </z-cell>
      <section class="upload-idcard">
        <media-upload-item ocr :sdkOptions="{ type: '1' }" authType="0" :cover="frontCover" :tip="frontTip" type="front" @uploaded="frontPicUploaded">
        </media-upload-item>
        <media-upload-item :sdkOptions="{ type: '1' }" authType="0" :cover="backCover" :tip="backTip" type="back" @uploaded="backPicUploaded">
        </media-upload-item>
      </section>

      <z-field
        v-model="name"
        name="name"
        label="法定代表人"
        label-width="100px"
        placeholder="请输入法定代表人"
      />

      <z-field
        v-model="idCard"
        name="idCard"
        label="身份证号"
        label-width="100px"
        placeholder="请输入身份证号"
      />
    </z-cell-group>

      <z-button-group>
        <z-button type="primary" btn-class="bottombtn" loading-text="提交中..." native-type="submit" :disabled="disabled" :loading="btnLoading" :text="btnText" :style="isHeroClub ? heroClubButtonStyle : {}"></z-button>
      </z-button-group>
    </z-form>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Field, Button, ButtonGroup, Toast, Form, CellGroup, Cell } from '@zz-common/zz-ui'
import MediaUploadItem from '../../RealAuthNew/MediaUploadItem/MediaUploadItem';
import EvidenceUploadItem from '../../cloudInspection/MediaUploadItem/MediaUploadItem';
import { isHeroClubByUa } from '@lib/utils'

export default {
  name: 'QuaForm',
  data() {
    return {
      creditCode: '', //统一社会信用代码
      bizName: '', //企业名称
      bizPic: '', //
      name: '', //姓名
      idCard: '', //身份证号
      picFront: '', //身份证照片人像面
      picBack: '', //身份证照片国徽面
      frontCover: require('@assets/img/id_card_front_sample_new.png'),
      backCover: require('@assets/img/id_card_back_sample_new.png'),
      actions: [
        { name: '开始拍照', value: 1 },
        { name: '从相册上传', value: 2 }
      ],
      frontTip: '',
      backTip: '',
      isHeroClub: isHeroClubByUa(),
      heroClubButtonStyle: {
        background: '#111111',
        color: '#F2D3A9',
        border: '1px solid #111111'
      }
    }
  },
  props: {
    btnLoading: {
      type: Boolean,
      default: false
    },
    btnText: {
      type: String,
      default: '下一步'
    }
  },
  computed: {
    disabled() {
      return (
        this.creditCode === '' ||
        this.bizName === '' ||
        this.bizPic === '' ||
        this.name === '' ||
        this.idCard === '' ||
        this.picFront === '' ||
        this.picBack === ''
      )
    }
  },
  components: {
    zButtonGroup: ButtonGroup,
    zButton: Button,
    zField: Field,
    zForm: Form,
    zCellGroup: CellGroup,
    zCell: Cell,
    MediaUploadItem,
    EvidenceUploadItem
  },
  methods: {
    onSubmit(values) {
      const params = {
        ...values,
        bizPic: this.bizPic,
        picFront: this.picFront,
        picBack: this.picBack
      }
      if (this.disabled) return Toast('请填写所有内容再提交')
      this.$emit('handleSubmit', params)
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
      Toast('failed');
    },
    frontPicUploaded(rst, ocr = '') {
      this.picFront = rst
      if (ocr && !this.name && !this.cardId) {
        this.name = ocr.name
        this.idCard = ocr.cardId
      }
    },
    backPicUploaded(rst) {
      this.picBack = rst
    },
    UploadedEvi(rst, params1, params2, ocr) {
      this.bizPic = rst
      if (ocr && !this.name && !this.cardId) {
        this.bizName = ocr.businessName
        this.creditCode = ocr.creditCode
      }
    }
  },
  mounted() {
    console.log('mounted');
    native.setTitle({
      title: '资质提交'
    })
    console.log('setTitle');
  }
}
</script>

<style lang="less">
  @import 'index.less';
</style>
